/**
 * Generated by orval v8.9.0 🍺
 * Do not edit manually.
 * PopulateEMR
 * OpenAPI spec version: v1
 */

export type RecurrenceTypes = typeof RecurrenceTypes[keyof typeof RecurrenceTypes];


export const RecurrenceTypes = {
  Single: 'Single',
  Daily: 'Daily',
  Weekly: 'Weekly',
} as const;
